<div class="kiezer" role="dialog" aria-labelledby="kiezer-titel">
  <div class="kiezer-kop">
    <h2 id="kiezer-titel">{{ (huidig ? 'CLUB_KIEZER.switch' : 'CLUB_KIEZER.choose') | translate }}</h2>
    @if (sluitbaar) {
      <button type="button" class="kiezer-sluit" (click)="sluit()" [attr.aria-label]="'CLUB_KIEZER.close' | translate">
        <svg-icon src="assets/icons/close.svg" [svgStyle]="{ 'width.px': 14, 'height.px': 14 }"></svg-icon>
      </button>
    }
  </div>

  <div class="kiezer-zoek">
    <svg-icon src="assets/icons/search-white.svg" [svgStyle]="{ 'width.px': 16, 'height.px': 16 }"></svg-icon>
    <input #zoekveld
           type="search"
           autocomplete="off"
           [value]="zoek()"
           (input)="onZoek($any($event.target).value)"
           (keydown.enter)="kiesEerste()"
           [placeholder]="'CLUB_KIEZER.search' | translate"
           [attr.aria-label]="'CLUB_KIEZER.search' | translate">
  </div>

  <div class="kiezer-lijst">
    @if (fout()) {
      <p class="kiezer-melding">{{ 'CLUB_KIEZER.error_list' | translate }}</p>
    } @else if (keuzes() === null) {
      <p class="kiezer-melding">{{ 'CLUB_KIEZER.loading' | translate }}</p>
    } @else if (nietsGevonden()) {
      <p class="kiezer-melding">{{ 'CLUB_KIEZER.none' | translate }}</p>
    }

    @for (groep of lijst(); track groep.sleutel) {
      <div class="kiezer-groep">{{ groep.titel | translate }}</div>
      @for (keuze of groep.items; track keuze.club) {
        <button type="button"
                class="kiezer-rij"
                [class.huidig]="keuze.club === huidig"
                [disabled]="!!bezig()"
                (click)="kies(keuze)">
          <svg-icon [src]="icoon(keuze)" [svgStyle]="{ 'width.px': 16, 'height.px': 16 }"></svg-icon>
          <span class="kiezer-naam">{{ keuze.name }}</span>
          @if (bezig() === keuze.club) {
            <span class="kiezer-soort">{{ 'CLUB_KIEZER.opening' | translate }}</span>
          } @else if (keuze.kind === 'league') {
            <span class="kiezer-soort">{{ 'CLUB_KIEZER.league' | translate }}</span>
          } @else if (keuze.kind === 'tagging') {
            <span class="kiezer-soort">{{ 'CLUB_KIEZER.tagging_team' | translate }}</span>
          }
          @if (keuze.club === huidig) {
            <span class="kiezer-vink" aria-hidden="true">✓</span>
          }
        </button>
      }
    }
  </div>

  <div class="kiezer-voet">
    <span>{{ 'CLUB_KIEZER.hint' | translate }}</span>
    <span class="kiezer-voet-knoppen">
      @if (installer(); as studio) {
        <a class="kiezer-installer" [href]="studio.url" rel="noopener">{{ 'CLUB_KIEZER.install_studio' | translate: { versie: studio.versie } }}</a>
      }
      <button type="button" (click)="stop()">{{ 'CLUB_KIEZER.exit' | translate }}</button>
    </span>
  </div>
</div>
